
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/programme/[uid]",
      function () {
        return require("private-next-pages/programme/[uid].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/programme/[uid]"])
      });
    }
  